// import './App.css';
// import { createBrowserRouter, RouterProvider} from 'react-router-dom';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import 'jquery/dist/jquery.slim.min';
// import 'popper.js/dist/umd/popper.min';
// import Login from './Login';
// // import Dashboard from './Dashboard';
// import Fintech from './fintech/Fintech';
// import AddFintech from './fintech/AddFintech';
// import ViewFintech from './fintech/ViewFintech';
// import ViewCustomer from './operation/ViewCustomer';
// import KYC from './operation/KYC';
// import CreditCheck from './operation/CreditCheck';
// import Reject from './operation/Reject';
// import AllCustomer from './operation/AllCustomer';
// import BankVerification from './operation/BankVerification';
// import OverDue from './OverDue';
// import Document from './headerfile/Document';
// import CreditReport from './headerfile/CreditReport';
// import LoanAgreement from './headerfile/LoanAgreement';
// import NOC from './headerfile/NOC';
// import PendingDisbursement from './account/PendingDisbursement';
// import Disbursement from './account/Disbursement';
// import AddCustomer from './operation/AddCustomer';
// import Testing from './Testing';
// import TodayRepayment from './TodayRepayment';
// import Profile from './Profile';
// import Setting from './Setting';
// import VerifiedCustomer from './operation/VerifiedCustomer';
// import ViewVerifiedCustomer from './operation/ViewVerifiedCustomer';
// import ViewReject from './operation/ViewReject';
// // import Employee from './operation/Employee';
// import AddProduct from './loanmaster/AddProduct';
// import Product from './loanmaster/Product';
// import ViewProduct from './loanmaster/ViewProduct';
// import BorrowerAgreement from './headerfile/BorrowerAgreement';
// import Collection from './excel/Collection';
// import Disbursed from './excel/Disbursed';
// import MasterSheet from './excel/MasterSheet';
// import Customer from './operation/Customer';
// import AllEmployee from './employee/AllEmployee';
// import AddEmployee from './employee/AddEmployee';
// import ViewEmployee from './employee/ViewEmployee';
// import LoanDocuments from './document/LoanDocuments';
// import Loan from './loanmaster/Loan';
// import ViewLoan from './loanmaster/ViewLoan';
// import LoanList from './loanmaster/LoanList';
// import Dashboard from './Dashboard';


// function App() {
//     const router = createBrowserRouter([
//         {
//             path: "/",
//             element: <Login />
//         },
//         // {
//         //     path: "/Dashboard",
//         //     element: <Dashboard />
//         //   },
//         {
//             path: "Dashboard",
//             element: <Dashboard />
//         },
//         {
//             path: "/fintech/Fintech",
//             element: <Fintech />
//         },
//         {
//             path: "/fintech/AddFintech",
//             element: <AddFintech />
//         },
//         {
//             path: "/fintech/ViewFintech",
//             element: <ViewFintech />
//         },
//         {
//             path: "/operation/Customer",
//             element: <Customer />
//         },
//         {
//             path: "/operation/VerifiedCustomer",
//             element: <VerifiedCustomer/>
//         },
//         {
//             path: "/operation/ViewVerifiedCustomer",
//             element: <ViewVerifiedCustomer/>
//         },
//         {
//             path: "/operation/ViewCustomer",
//             element: <ViewCustomer/>
//         },
//         {
//             path: "/operation/KYC",
//             element: <KYC />
//         },
//         {
//             path: "/operation/CreditCheck",
//             element: <CreditCheck />
//         },
//         {
//             path: "/operation/Reject",
//             element: <Reject />
//         },
//         {
//             path: "/operation/ViewReject",
//             element: <ViewReject />
//         },
//         {
//             path: "/operation/AllCustomer",
//             element: <AllCustomer />
//         },
//         {
//             path: "/operation/AddCustomer",
//             element: <AddCustomer />
//         },
//         {
//             path: "/operation/BankVerification",
//             element: <BankVerification />
//         },
       
//         {
//             path: "/OverDue",
//             element: <OverDue />
//         },
       
//         {
//             path: "/TodayRepayment",
//             element: <TodayRepayment />
//         },
//         {
//             path: "/headerfile/CreditReport",
//             element: <CreditReport />
//         },
//         {
//             path: "/headerfile/Document",
//             element: <Document/>
//         },
//         {
//             path: "/headerfile/LoanAgreement",
//             element: <LoanAgreement />
//         },
//         {
//             path: "/headerfile/NOC",
//             element: <NOC />
//         },
//         {
//             path: "/loanmaster/AddProduct",
//             element: <AddProduct />
//         },
//         {
//             path: "/loanmaster/Product",
//             element: <Product />
//         },
//         {
//             path: "/loanmaster/ViewProduct",
//             element: <ViewProduct />
//         },
//          {
//             path: "/loanmaster/ViewLoan",
//             element: <ViewLoan />
//         },
//         {
//             path: "/loanmaster/Loan",
//             element: <Loan/>
//         },
//         {
//             path: "/loanmaster/LoanList",
//             element: <LoanList/>
//         },
//         {
//             path: "/account/PendingDisbursement",
//             element: <PendingDisbursement/>
//         },
//         {
//             path: "/account/Disbursement",
//             element: <Disbursement/>
//         }, 
//         {
//             path: "/Testing",
//             element: <Testing/>
//         }, 
//         {
//             path: "/Profile",
//             element: <Profile />
//         },
//         {
//             path: "/Setting",
//             element: <Setting />
//         },
//         {
//             path: "/headerfile/BorrowerAgreement",
//             element: <BorrowerAgreement />
//         },
//         {
//             path: "/Excel/Collection",
//             element: <Collection />
//         },
//         {
//             path: "/Excel/Disbursed",
//             element: <Disbursed />
//         },
//         {
//             path: "/Excel/MasterSheet",
//             element: <MasterSheet />
//         },
//         {
//             path: "/employee/AllEmployee",
//             element: <AllEmployee />
//         },
//         {
//             path: "/employee/AddEmployee",
//             element: <AddEmployee />
//         },
//         {
//             path: "/employee/ViewEmployee",
//             element: <ViewEmployee />
//         },
//          {
//             path: "/document/LoanDocuments",
//             element: <LoanDocuments />
//         },
//     ]);
//     return (
//         <RouterProvider router={router} />
//     );
// }

// export default App;




// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import './App.css';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import 'jquery/dist/jquery.slim.min';
// import 'popper.js/dist/umd/popper.min';
// import Login from './Login';
// import Dashboard from './Dashboard';
// import Fintech from './fintech/Fintech';
// import AddFintech from './fintech/AddFintech';
// import ViewFintech from './fintech/ViewFintech';
// import ViewCustomer from './operation/ViewCustomer';
// import KYC from './operation/KYC';
// import CreditCheck from './operation/CreditCheck';
// import Reject from './operation/Reject';
// import AllCustomer from './operation/AllCustomer';
// import BankVerification from './operation/BankVerification';
// import OverDue from './OverDue';
// import Document from './headerfile/Document';
// import CreditReport from './headerfile/CreditReport';
// import LoanAgreement from './headerfile/LoanAgreement';
// import NOC from './headerfile/NOC';
// import PendingDisbursement from './account/PendingDisbursement';
// import Disbursement from './account/Disbursement';
// import AddCustomer from './operation/AddCustomer';
// import Testing from './Testing';
// import TodayRepayment from './TodayRepayment';
// import Profile from './Profile';
// import Setting from './Setting';
// import VerifiedCustomer from './operation/VerifiedCustomer';
// import ViewVerifiedCustomer from './operation/ViewVerifiedCustomer';
// import ViewReject from './operation/ViewReject';
// // import Employee from './operation/Employee';
// import AddProduct from './loanmaster/AddProduct';
// import Product from './loanmaster/Product';
// import ViewProduct from './loanmaster/ViewProduct';
// import BorrowerAgreement from './headerfile/BorrowerAgreement';
// import Collection from './excel/Collection';
// import Disbursed from './excel/Disbursed';
// import MasterSheet from './excel/MasterSheet';
// import Customer from './operation/Customer';
// import AllEmployee from './employee/AllEmployee';
// import AddEmployee from './employee/AddEmployee';
// import ViewEmployee from './employee/ViewEmployee';
// import LoanDocuments from './document/LoanDocuments';
// import Loan from './loanmaster/Loan';
// import ViewLoan from './loanmaster/ViewLoan';
// import LoanList from './loanmaster/LoanList';
// // import Dashboard from './Dashboard';
// // ... (all other imports same)

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/Dashboard" element={<Dashboard />} />
//         <Route path="/fintech/Fintech" element={<Fintech />} />
//         <Route path="/fintech/AddFintech" element={<AddFintech />} />
//         <Route path="/fintech/ViewFintech" element={<ViewFintech />} />
//         <Route path="/operation/Customer" element={<Customer />} />
//         <Route path="/operation/VerifiedCustomer" element={<VerifiedCustomer />} />
//         <Route path="/operation/ViewVerifiedCustomer" element={<ViewVerifiedCustomer />} />
//         <Route path="/operation/ViewCustomer" element={<ViewCustomer />} />
//         <Route path="/operation/KYC" element={<KYC />} />
//         <Route path="/operation/CreditCheck" element={<CreditCheck />} />
//         <Route path="/operation/Reject" element={<Reject />} />
//         <Route path="/operation/ViewReject" element={<ViewReject />} />
//         <Route path="/operation/AllCustomer" element={<AllCustomer />} />
//         <Route path="/operation/AddCustomer" element={<AddCustomer />} />
//         <Route path="/operation/BankVerification" element={<BankVerification />} />
//         <Route path="/OverDue" element={<OverDue />} />
//         <Route path="/TodayRepayment" element={<TodayRepayment />} />
//         <Route path="/headerfile/CreditReport" element={<CreditReport />} />
//         <Route path="/headerfile/Document" element={<Document />} />
//         <Route path="/headerfile/LoanAgreement" element={<LoanAgreement />} />
//         <Route path="/headerfile/NOC" element={<NOC />} />
//         <Route path="/loanmaster/AddProduct" element={<AddProduct />} />
//         <Route path="/loanmaster/Product" element={<Product />} />
//         <Route path="/loanmaster/ViewProduct" element={<ViewProduct />} />
//         <Route path="/loanmaster/ViewLoan" element={<ViewLoan />} />
//         <Route path="/loanmaster/Loan" element={<Loan />} />
//         <Route path="/loanmaster/LoanList" element={<LoanList />} />
//         <Route path="/account/PendingDisbursement" element={<PendingDisbursement />} />
//         <Route path="/account/Disbursement" element={<Disbursement />} />
//         <Route path="/Testing" element={<Testing />} />
//         <Route path="/Profile" element={<Profile />} />
//         <Route path="/Setting" element={<Setting />} />
//         <Route path="/headerfile/BorrowerAgreement" element={<BorrowerAgreement />} />
//         <Route path="/Excel/Collection" element={<Collection />} />
//         <Route path="/Excel/Disbursed" element={<Disbursed />} />
//         <Route path="/Excel/MasterSheet" element={<MasterSheet />} />
//         <Route path="/employee/AllEmployee" element={<AllEmployee />} />
//         <Route path="/employee/AddEmployee" element={<AddEmployee />} />
//         <Route path="/employee/ViewEmployee" element={<ViewEmployee />} />
//         <Route path="/document/LoanDocuments" element={<LoanDocuments />} />
//       </Routes>
//       <Route path="/Dashboard" element={
//   <ProtectedRoute>
//     <Dashboard />
//   </ProtectedRoute>
// } />
// <Route path="/fintech/Fintech" element={
//   <ProtectedRoute>
//     <Fintech />
//   </ProtectedRoute>
// } />
//     </BrowserRouter>
//   );
// }

// export default App;

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'jquery/dist/jquery.slim.min';
import 'popper.js/dist/umd/popper.min';

import Login from './Login';
import Dashboard from './Dashboard';
import Fintech from './fintech/Fintech';
import AddFintech from './fintech/AddFintech';
import ViewFintech from './fintech/ViewFintech';
import ViewCustomer from './operation/ViewCustomer';
import KYC from './operation/KYC';
import CreditCheck from './operation/CreditCheck';
import Reject from './operation/Reject';
import AllCustomer from './operation/AllCustomer';
import BankVerification from './operation/BankVerification';
import OverDue from './OverDue';
import Document from './headerfile/Document';
import CreditReport from './headerfile/CreditReport';
import LoanAgreement from './headerfile/LoanAgreement';
import NOC from './headerfile/NOC';
import PendingDisbursement from './account/PendingDisbursement';
import Disbursement from './account/Disbursement';
import AddCustomer from './operation/AddCustomer';
import Testing from './Testing';
import TodayRepayment from './TodayRepayment';
import Profile from './Profile';
import Setting from './Setting';
import VerifiedCustomer from './operation/VerifiedCustomer';
import ViewVerifiedCustomer from './operation/ViewVerifiedCustomer';
import ViewReject from './operation/ViewReject';
import AddProduct from './loanmaster/AddProduct';
import Product from './loanmaster/Product';
import ViewProduct from './loanmaster/ViewProduct';
import BorrowerAgreement from './headerfile/BorrowerAgreement';
import Collection from './excel/Collection';
import Disbursed from './excel/Disbursed';
import MasterSheet from './excel/MasterSheet';
import Customer from './operation/Customer';
import AllEmployee from './employee/AllEmployee';
import AddEmployee from './employee/AddEmployee';
import ViewEmployee from './employee/ViewEmployee';
import LoanDocuments from './document/LoanDocuments';
import Loan from './loanmaster/Loan';
import ViewLoan from './loanmaster/ViewLoan';
import LoanList from './loanmaster/LoanList';

import ProtectedRoute from './ProtectedRoute';
import AppLayout from './components/AppLayout';
import Repayment from './loanmaster/Repayment';
import ReportsDashboard from './excel/Disbursed';
import UserTabPermissions from './privllages/Permissions';
import MultipleLoans from './loanmaster/MultipleLoans';
import LoanDeactivate from './excel/LoanDeactivate';
import EmiUpload from './excel/EmiUpload';
import AutoDebitMandates from './AutoDebitMandates';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public route - login */}
        <Route path="/" element={<Login />} />

        {/* Protected routes - AppLayout mein wrapped (Navigation + Sidebar ek baar) */}
        <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/fintech/Fintech" element={<Fintech />} />
          <Route path="/fintech/AddFintech" element={<AddFintech />} />
          <Route path="/fintech/ViewFintech" element={<ViewFintech />} />
          <Route path="/operation/Customer" element={<Customer />} />
          <Route path="/operation/VerifiedCustomer" element={<VerifiedCustomer />} />
          <Route path="/operation/ViewVerifiedCustomer" element={<ViewVerifiedCustomer />} />
          <Route path="/operation/ViewCustomer" element={<ViewCustomer />} />
          <Route path="/operation/KYC" element={<KYC />} />
          <Route path="/operation/CreditCheck" element={<CreditCheck />} />
          <Route path="/operation/Reject" element={<Reject />} />
          <Route path="/operation/ViewReject" element={<ViewReject />} />
          <Route path="/operation/AllCustomer" element={<AllCustomer />} />
          <Route path="/operation/AddCustomer" element={<AddCustomer />} />
          <Route path="/operation/BankVerification" element={<BankVerification />} />
          <Route path="/OverDue" element={<OverDue />} />
          <Route path="/TodayRepayment" element={<TodayRepayment />} />
          <Route path="/headerfile/CreditReport" element={<CreditReport />} />
          <Route path="/headerfile/Document" element={<Document />} />
          <Route path="/headerfile/LoanAgreement" element={<LoanAgreement />} />
          <Route path="/headerfile/NOC" element={<NOC />} />
          <Route path="/loanmaster/AddProduct" element={<AddProduct />} />
          <Route path="/loanmaster/Product" element={<Product />} />
          <Route path="/loanmaster/ViewProduct" element={<ViewProduct />} />
          <Route path="/loanmaster/ViewLoan" element={<ViewLoan />} />
          <Route path="/loanmaster/Loan" element={<Loan />} />
          <Route path="/loanmaster/LoanList" element={<LoanList />} />
          <Route path="/account/PendingDisbursement" element={<PendingDisbursement />} />
          <Route path="/account/Disbursement" element={<Disbursement />} />
          <Route path="/Testing" element={<Testing />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/headerfile/BorrowerAgreement" element={<BorrowerAgreement />} />
          <Route path="/Excel/Collection" element={<Collection />} />
          <Route path="/Excel/Disbursed" element={<Disbursed />} />
          <Route path="/Excel/MasterSheet" element={<MasterSheet />} />
          <Route path="/employee/AllEmployee" element={<AllEmployee />} />
          <Route path="/employee/AddEmployee" element={<AddEmployee />} />
          <Route path="/employee/ViewEmployee" element={<ViewEmployee />} />
          <Route path="/document/LoanDocuments" element={<LoanDocuments />} />
          <Route path="/loanmaster/Repayment" element={<Repayment />} />
          <Route path="/Excel/ReportsDashboard" element={<ReportsDashboard />} />
          <Route path="/privllages/Permissions" element={<UserTabPermissions />} />
          <Route path="/loanmaster/MultipleLoans" element={<MultipleLoans />} />
          <Route path="/Excel/LoanDeactivate" element={<LoanDeactivate />} />
          <Route path="/Excel/EmiUpload" element={<EmiUpload />} />
          <Route path="/AutoDebitMandates" element={<AutoDebitMandates />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
